import {
	adminClient,
	inferAdditionalFields,
	magicLinkClient,
	organizationClient,
	passkeyClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { auth } from ".";

const getBaseURL = () => {
	if (typeof window !== "undefined") {
		// Browser should use relative path
		return window.location.origin;
	}
	// SSR should use localhost
	return "http://localhost:3000";
};

export const authClient = createAuthClient({
	baseURL: getBaseURL(),
	plugins: [
		inferAdditionalFields<typeof auth>(),
		magicLinkClient(),
		organizationClient(),
		adminClient(),
		passkeyClient(),
	],
});

export type AuthClientErrorCodes = typeof authClient.$ERROR_CODES & {
	INVALID_INVITATION: string;
};
